import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

// --- Interfaces ---
import type { IFavorites } from '@interfaces/favorite';
import type { IProduct } from '@interfaces/product';

export interface IGetFavoritesParams
	extends Partial<{
		userId: number;
		priceListId: number;
		storeId: number;
		tenantId: number;
		page: number;
		pageLimit: number;
	}> {}

@Injectable({
	providedIn: 'root',
})
export class FavoritesService {
	constructor(private readonly _http: HttpClient) {}

	// --- GET endpoints ---
	getFavorites(queryParams?: IGetFavoritesParams) {
		return this._http.get<IFavorites>('favorites', {
			params: (<unknown>queryParams) as HttpParams,
		});
	}

	// --- POST endpoints ---
	favoriteProducts(productIds: IProduct['id'][]) {
		return this._http.post<IFavorites>('favorites', { productIds });
	}

	unfavoriteProducts(productIds: IProduct['id'][]) {
		return this._http.post<IFavorites>('favorites/unfavorite', { productIds });
	}
}
